import Footer from "../Footer";

export default function PageLayout({children, isMobile, setShowHelp}) {
    return(
        <div 
            style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh"
                }}>
            <main style={{ flex: "1", backgroundColor: 'black', color: '#ccc' }}>
                {children}
            </main>
            <Footer isMobile={isMobile} setShowHelp={setShowHelp}/>
        </div>
    )
}